<template>
  <div>
    <p v-text="notice" :class="`${notice ? 'border-2  bg-neutral p-2 text-black text-lg my-2 rounded-md' : ''}`" />
    <p v-text="alert" :class="`${alert ? 'border-2  bg-accent-primary p-2 text-black text-lg my-2 rounded-md' : ''}`" />
  </div>
</template>


<script lang="ts" setup>
import { useNoticesStore } from '@/stores/notices'
import { computed, onMounted } from 'vue'

const noticesStore = useNoticesStore()
const notice = computed(() => noticesStore.notice)
const alert = computed(() => noticesStore.alert)

onMounted(() => {
  setTimeout(() => {
    noticesStore.clear()
  }, 30000)
})

</script>